const clean = (value = "") => String(value ?? "").replace(/\s+/g, " ").trim();

export const parsePromoStoreSyncProductId = (value = "") => {
  const parts = clean(value).split(":");
  const promoStoreIndex = parts.indexOf("promostore");
  const itemIndex = parts.indexOf("item");
  const variantIndex = parts.indexOf("variant");
  if (promoStoreIndex === -1 || itemIndex === -1 || itemIndex + 1 >= parts.length) return null;
  return {
    promoStoreId: Number(parts[promoStoreIndex + 1]),
    itemId: Number(parts[itemIndex + 1]),
    variantToken: variantIndex >= 0 ? clean(parts[variantIndex + 1]) : "",
    colorSlug: variantIndex >= 0 ? clean(parts[variantIndex + 2]) : "",
    sizeSlug: variantIndex >= 0 ? clean(parts.slice(variantIndex + 3).join("-")) : "",
    raw: clean(value),
  };
};

export const getPromoStoreSyncProductId = (line = {}) => [
  line.sync_product_id,
  line.elitecore_sync_product_id,
  line.rawPayload?.sync_product_id,
  line.rawPayload?.elitecore_sync_product_id,
].find((value) => value !== undefined && value !== null && value !== "") || "";

export const resolvePromoStoreItemId = ({ directItemId = "", line = {}, promoStoreId = "" } = {}) => {
  if (directItemId !== undefined && directItemId !== null && directItemId !== "") return directItemId;
  const parsed = parsePromoStoreSyncProductId(getPromoStoreSyncProductId(line));
  if (!parsed || String(parsed.promoStoreId) !== String(promoStoreId)) return "";
  return parsed.itemId;
};
